import { apiClient } from './api';

// EG-52 — Platform Admin xem BIDV refund bank cross-tenant.
// BE endpoint: GET /bidv-refund-banks, GET /bidv-refund-banks/:id (read-only).

export interface BidvRefundBankFilters {
  page?: number;
  limit?: number;
  tenant_id?: string;
  status?: number;
  q?: string;
}

export interface BidvRefundBank {
  bank_id: string;
  tenant_id?: string;
  name: string;
  code: string;
  icon?: string;
  status: number;
  ordering: number;
  created_at?: string;
  updated_at?: string;
}

export interface BidvRefundBanksResponse {
  data: BidvRefundBank[];
  meta: { page: number; limit: number; total: number; totalPages: number };
}

interface Envelope<T> {
  success: boolean;
  data: T;
}

interface BidvRefundBankApiRaw {
  bank_id?: string;
  _id?: string;
  tenant_id?: string;
  name?: string;
  code?: string;
  icon?: string;
  status?: number;
  ordering?: number;
  created_at?: string;
  updated_at?: string;
}

const toBidvRefundBank = (raw: BidvRefundBankApiRaw): BidvRefundBank => ({
  bank_id: raw.bank_id || raw._id || '',
  tenant_id: raw.tenant_id,
  name: raw.name || '',
  code: raw.code || '',
  icon: raw.icon,
  status: raw.status ?? 1,
  ordering: raw.ordering ?? 0,
  created_at: raw.created_at,
  updated_at: raw.updated_at,
});

export const bidvService = {
  getRefundBanks: async (filters: BidvRefundBankFilters = {}): Promise<BidvRefundBanksResponse> => {
    const response = await apiClient.get<Envelope<{ items: BidvRefundBankApiRaw[]; meta: BidvRefundBanksResponse['meta'] }>>(
      '/bidv-refund-banks',
      { params: filters },
    );
    const payload = response.data?.data;
    return {
      data: (payload?.items || []).map(toBidvRefundBank),
      meta: payload?.meta || {
        page: filters.page || 1,
        limit: filters.limit || 20,
        total: 0,
        totalPages: 0,
      },
    };
  },

  getRefundBankById: async (id: string): Promise<BidvRefundBank> => {
    const response = await apiClient.get<Envelope<BidvRefundBankApiRaw>>(`/bidv-refund-banks/${id}`);
    return toBidvRefundBank(response.data.data);
  },
};

export default bidvService;
